import { minValue, maxValue, required } from 'vuelidate/lib/validators';

const validations = () => ({
  parametersCopy: {
    typicalValueH2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueCh4: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueC2h6: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueC2h4: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueC2h2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueCo: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueCo2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueO2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueN2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueTaxH2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueTaxCh4: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueTaxC2h6: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueTaxC2h4: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueTaxC2h2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueTaxCo: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueTaxCo2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueTaxO2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    typicalValueTaxN2: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    minimumCorrelationEmissionAlarmsElectricArc: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    minimumCorrelationEmissionAlarmsElectrolysis: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    minimumCorrelationEmissionAlarmsOverheatedOil: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    minimumCorrelationEmissionAlarmsOverheatedPaper: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    minimumCorrelationEmissionAlarmsPartialDownloads: {
      minValue: minValue(0),
      maxValue: maxValue(1000000),
    },
    entryCriteria: {
      required,
    },
    gasesLimit: {
      h2: {
        minValue: minValue(0.1),
        maxValue: maxValue(1000000),
      },
      c2H6: {
        minValue: minValue(0.1),
        maxValue: maxValue(1000000),
      },
      c2H4: {
        minValue: minValue(0.1),
        maxValue: maxValue(1000000),
      },
      c2H2: {
        minValue: minValue(0.1),
        maxValue: maxValue(1000000),
      },
      cH4: {
        minValue: minValue(0.1),
        maxValue: maxValue(1000000),
      },
      co: {
        minValue: minValue(0.1),
        maxValue: maxValue(1000000),
      },
    },
  },
});

export default validations;
